import { render, staticRenderFns } from "./ActivateAndDeactivateConfigs.vue?vue&type=template&id=05f1d5c2&"
import script from "./ActivateAndDeactivateConfigs.vue?vue&type=script&lang=js&"
export * from "./ActivateAndDeactivateConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports